import Helper from '@ember/component/helper';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

export default class CurrentTimeHelper extends Helper {
  constructor() {
    super(...arguments);
    this.interval = setInterval(() => {
      this.recompute(); // Forces the helper to run compute() again
    }, 1000); // Re-renders every 1 second
  }

  compute(value, { interval }) {
    dayjs.extend(relativeTime);
    return dayjs(value[0]).from(new Date(), false);
  }

  destroy() {
    clearInterval(this.interval);
    super.destroy(...arguments);
  }
}
